import { render, staticRenderFns } from "./productBrochureStyle.vue?vue&type=template&id=733617d9&scoped=true"
import script from "./productBrochureStyle.vue?vue&type=script&lang=js"
export * from "./productBrochureStyle.vue?vue&type=script&lang=js"
import style0 from "./productBrochureStyle.vue?vue&type=style&index=0&id=733617d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733617d9",
  null
  
)

export default component.exports